import {
    httpRequest
} from './httpsRequest';

export const assignUserRole = (userId, organizations) => {
    organizations.forEach((org) => {
    // Check if the user is a superAdmin
        if (org?.superAdmin?._id === userId) {
            org.userRole = 'superAdmin';
        } else {
            // If not a superAdmin, check if the user is a member.
            // Defensive: members may contain rows with `id: null` (orphaned/deleted users
            // that were never cleaned up). Skip those instead of throwing.
            const userMember = (org?.members || []).find(
                (member) => member?.id?._id === userId,
            );
            if (userMember) {
                org.userRole = userMember.role;
            } else {
                org.userRole = null;
            }
        }
    });

    // Return the organizations array with roles assigned
    return organizations;
};

export const getOrganizationMember = async (id, orgData) => {
    if (!id || !orgData) return '';

    const superAdmin = orgData.superAdmin;
    const superAdminId = superAdmin?._id ?? superAdmin;
    if (superAdminId && String(superAdminId) === String(id)) {
        return superAdmin?.name || '';
    }

    const member = (orgData.members || []).find((item) => {
        const memberId = item?.id?._id ?? item?.id;
        return memberId && String(memberId) === String(id);
    });
    if (member) {
        return member?.id?.name || member?.name || '';
    }

    return '';
};

export const buildOrganizationMemberNames = (orgData) => {
    const names = new Map();
    if (!orgData) return names;

    const superAdmin = orgData.superAdmin;
    const superAdminId = superAdmin?._id ?? superAdmin;
    if (superAdminId) {
        names.set(String(superAdminId), superAdmin?.name || '');
    }

    for (const item of orgData.members || []) {
        const memberId = item?.id?._id ?? item?.id;
        if (!memberId) continue;
        names.set(String(memberId), item?.id?.name || item?.name || '');
    }

    return names;
};

export const handleLeaveOrganization = async (oragID, userId) => {
    const leaveOrgObj = {
        organizationId: oragID,
        userId: userId,
    };
    try {
        await httpRequest.post(
            '/db/organizations/update_organization/leave-organization',
            leaveOrgObj
        );

        window.location = '/organizations';
    } catch (error) {

        throw new Error(error);
    }
};

export function getRoleAccessLevel(role) {
    switch (role) {
        case 'superAdmin':
            return 3;
        case 'admin':
            return 2;
        case 'editor':
            return 1;
        default:
            return 0;
    }
}
